// extracted by mini-css-extract-plugin
export default {"sponsorship":"sponsorship_sponsorship__GCcXX"};